import { render } from "./ModalFiltroFuncionario.vue?vue&type=template&id=ed63690a&ts=true"
import script from "./ModalFiltroFuncionario.vue?vue&type=script&lang=ts"
export * from "./ModalFiltroFuncionario.vue?vue&type=script&lang=ts"

import "./ModalFiltroFuncionario.vue?vue&type=style&index=0&id=ed63690a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__